import { render, staticRenderFns } from "./PermissionMixin.vue?vue&type=template&id=64d52b58&scoped=true&"
import script from "./PermissionMixin.vue?vue&type=script&lang=ts&"
export * from "./PermissionMixin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d52b58",
  null
  
)

export default component.exports